module.exports = __webpack_public_path__ + "static/media/dropdown.68686875.svg";